import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";

import { influencerActionsEnum } from "@entities/brief/lib/constants";
import { BriefTimelinePopOver } from "@features/briefTimeline/BriefTimelinePopOver";
import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import { Button } from "@shared/ui/Button";
import { Modal, Space } from "antd";
import { formatDate } from "date-fns";
import { useState } from "react";
import { AskInfluencerCommercials } from "./askInfluencerCommercials/AskInfluencerCommercials";
import InflunencerCommercialsDropDown from "./InfluencerCommercialsDropDown/InflunencerCommercialsDropDown";
import styles from "./styles.module.scss";

export function BriefInfluencerCommercials({
  briefInfluencer,
  inBrief = true,
}: {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  inBrief?: boolean;
}) {
  const [isCommercialsRequestedModal, setIsCommercialsRequestedModal] =
    useState(false);

  return (
    <div>
      {briefInfluencer?.influencerCost ? (
        <Space size={2}>
          <div className={styles.influencerCostCell}>
            {inBrief && (
              <BriefTimelinePopOver
                briefInfluencer={briefInfluencer}
                type="influencer"
              />
            )}
            <div className={styles.influencerCostInfo}>
              <div className={styles.influencerCostAmount}>
                {briefInfluencer.influencerCost.cost}
              </div>
              <div className={styles.influencerCostMeta}>
                {briefInfluencer.influencerCost.createdAt
                  ? formatDate(
                      briefInfluencer.influencerCost.createdAt,
                      "dd/MM/yy"
                    )
                  : "--"}
              </div>
            </div>
          </div>
          {inBrief && (
            <InflunencerCommercialsDropDown
              briefInfluencer={briefInfluencer}
              actions={
                briefInfluencer?.isQueuedForPurchaseLot
                  ? []
                  : [
                      influencerActionsEnum.addNewInfluencerCommercial,
                      influencerActionsEnum.viewInfluencerCommercial,
                      influencerActionsEnum.negotiate,
                    ]
              }
            />
          )}
        </Space>
      ) : !briefInfluencer.isInfluencerCostAsked &&
        briefInfluencer?.isPrimaryContactAdded &&
        !briefInfluencer?.isQueuedForPurchaseLot ? (
        <Space size={2}>
          {inBrief && (
            <BriefTimelinePopOver
              briefInfluencer={briefInfluencer}
              type="influencer"
            />
          )}
          {/* <Button
            onClick={() => setIsCommercialsRequestedModal(true)}
            size="small"
          >
            Ask Commercial
          </Button> */}
          {inBrief && (
            <InflunencerCommercialsDropDown
              briefInfluencer={briefInfluencer}
              actions={[influencerActionsEnum.addInfluencerCommercial]}
            />
          )}
        </Space>
      ) : briefInfluencer?.isInfluencerCostAsked ? (
        <Space size={2}>
          {inBrief && (
            <BriefTimelinePopOver
              briefInfluencer={briefInfluencer}
              type="influencer"
            />
          )}
          <Button
            type="link"
            danger
            size="small"
            className={styles.tooltipButton}
          >
            Commercials Requested
          </Button>
          {inBrief && (
            <InflunencerCommercialsDropDown
              briefInfluencer={briefInfluencer}
              actions={
                briefInfluencer?.isQueuedForPurchaseLot
                  ? []
                  : [
                      influencerActionsEnum.addInfluencerCommercial,
                      influencerActionsEnum.resend,
                    ]
              }
            />
          )}
        </Space>
      ) : (
        <div></div>
      )}
      <Modal
        open={isCommercialsRequestedModal}
        onCancel={() => setIsCommercialsRequestedModal(false)}
        // onClose={() => setIsCommercialsRequestedModal(false)}
        title="Ask Commercial"
        footer={null}
        width={1100}
        destroyOnClose
      >
        <AskInfluencerCommercials
          briefInfluencer={briefInfluencer}
          onClose={() => setIsCommercialsRequestedModal(false)}
        />
      </Modal>
    </div>
  );
}
